import styled from '@emotion/styled';
import rem from '../../utils/rem/rem';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
`;

export const H2 = styled.h2`
  font-family: 'Open Sans';
  font-size: ${rem(24)};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.gray800};
  margin-top: ${rem(40)};
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: ${rem(16)};
  margin: ${rem(68)};

  @media ${({ theme }) => theme.breakpoints.sm} {
    flex-direction: column;
  }
`